import script from "./GridAccountComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./GridAccountComponent.vue?vue&type=script&setup=true&lang=js"

import "./GridAccountComponent.vue?vue&type=style&index=0&id=69e64b9b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69e64b9b"]])

export default __exports__